import * as React from 'react';

import { Settings } from "@mui/icons-material"
import { Button, Divider, Grid, Typography, Card } from "@mui/material"
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { NavLink, useNavigate } from "react-router"

import Autocomplete from '@mui/material/Autocomplete';
import TextareaAutosize from '@mui/material/TextareaAutosize';

import { obtenerFechaHoy } from "../../utils/fechas"

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { BiSolidTruck } from "react-icons/bi";
import { BiSolidTime } from "react-icons/bi";
import { BiSolidCheckShield } from "react-icons/bi";
import { resizeImageAuto } from '../../utils/resizeImgUtil';

import { styled } from '@mui/material/styles';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { fromJSON } from 'postcss';
import { useTablon } from '../../contexts/contextGeneral';
import imagenotfound from '../../image/Image-not-found.png'
import { FcPlus } from "react-icons/fc";
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

function AddNewOrden(params) {

    const {
        vehiculos,
        companias,
        usuarios,
        getDataCrearOrden,
        idNewOrder,
    } = useTablon();

    React.useEffect(() => {
        getDataCrearOrden();
    }, []);


    const { postOrden } = useTablon()
    const navigate = useNavigate()


    const returnOrders = () => {
        navigate("/ordenes")
    }


    const [imageFile, setImageFile] = React.useState(null); // Estado para almacenar la imagen
    const [imageFileForm, setImageFileForm] = React.useState(null); // Estado para almacenar la imagen

    // Preview Imagen
    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return

        // Optimiza la Imagen, baja resolucion
        const optimized = await resizeImageAuto(file);

        setImageFileForm(optimized)
        const reader = new FileReader();

        reader.onloadend = () => {
            setImageFile(reader.result);
        };

        if (optimized) {
            reader.readAsDataURL(optimized);
        }
    };

    const [estatus, setEstatus] = React.useState(0);

    const handleChangeEstatus = (event) => {
        setEstatus(event.target.value);
    };

    const [fechaHoy, setFechaHoy] = React.useState(obtenerFechaHoy())
    const handleFechaHoy = (e) => {
        e.preventDefault();
        setFechaHoy(e.target.value)
    }

    const [empresa, setEmpresa] = React.useState(0)
    const handleEmpresa = (e) => {
        e.preventDefault();
        setEmpresa(e.target.value)
    }


    const [carro, setCarro] = React.useState(0)
    const handleCarro = (e) => {
        e.preventDefault();
        setCarro(e.target.value)
    }

    const [elaboro, setElaboro] = React.useState("")
    const handleChangeelaboro = (event) => {
        setElaboro(event.target.value)
    }

    const [buttonDisabled, setButtonDisabled] = React.useState(0)

    const [conceptos, setConceptos] = React.useState([
        {
            cantidad: 1,
            concepto: "",
            precio_unitario: ""
        }
    ]);

    const agregarConcepto = () => {
        setConceptos(prev => [
            ...prev,
            {
                cantidad: 1,
                concepto: "",
                precio_unitario: ""
            }
        ]);
    };

    const eliminarConcepto = (index) => {
        setConceptos(prev => prev.filter((_, i) => i !== index));
    };

    const cambiarConcepto = (index, campo, valor) => {
        setConceptos(prev =>
            prev.map((item, i) =>
                i === index
                    ? { ...item, [campo]: valor }
                    : item
            )
        );
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        setButtonDisabled(1)
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());

        // console.log(formJson);

        const formDataPayload = new FormData();

        let tempCarro = {}
        let tempEmpresa = {}

        if (carro == 0) {
            tempCarro = {
                placas: formJson.placas,
                marca: formJson.marca,
                modelo: formJson.modelo,
                color: formJson.color,
                vin: formJson.vin,
                kilometraje: formJson.kilo
            }
        } else {
            tempCarro = { id: carro }
        }

        if (empresa == 0) {
            tempEmpresa = {
                nombre: formJson.empresaNueva
            }
        } else {
            tempEmpresa = {
                id: empresa
            }
        }

        const payload = {
            responsables: {
                elaboro_id: formJson.elaboro,
            },
            orden: {
                fecha: formJson.fechaHoy,
                ot: idNewOrder,
                ot_externo: formJson.otExterno,
                kilometraje: formJson.kilo,
                observacion: formJson.observaciones,
                estatus: formJson.estatus
            },
            vehiculo: tempCarro,
            cliente: tempEmpresa,
            conceptos: conceptos.map(item => ({
                cantidad: Number(item.cantidad || 1),
                concepto: item.concepto,
                precio_unitario: Number(item.precio_unitario || 0)
            }))
        };


        formDataPayload.append("data", JSON.stringify(payload));
        formDataPayload.append("imagen_vehiculo", imageFileForm);


        try {
            const call = await postOrden(formDataPayload);
            if (call) {
                setButtonDisabled(0)
            }
        } catch (err) {
            setButtonDisabled(0)
            console.error(err.msg);
        }
    };

    const [busqueda, setBusqueda] = React.useState("");
    const vehiculosFiltrados = busqueda.trim()
        ? vehiculos.filter((v) =>
            v.placas.toLowerCase().startsWith(busqueda.toLowerCase())
        )
        : vehiculos.slice(-5);

    return (
        <>
            <form onSubmit={handleSubmit} id="nueva-orden-form">
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                        {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}> */}
                        <Typography variant='body1' color='warning' onClick={returnOrders}>Regresar a Ordenes</Typography>
                        {/* <Chip sx={{ marginRight: '10px' }} label={estatus(orden.estatus)} size='small' color={estatus(orden.estatus)} /> */}
                        {/* </div> */}
                        <center>
                            <Typography variant='h6' color='primary'>Completa el Formulario</Typography>
                            <Typography variant='h4' color='primary'><b>Nueva Orden</b></Typography>
                        </center>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Divider />
                    </Grid>
                </Grid>
                <Card sx={{ padding: "20px 10px", margin: '10px 0' }}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <center>
                                <Typography variant='h5' color='primary'><b>Datos de la Orden</b></Typography>
                            </center>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                id="fechaHoy"
                                name="fechaHoy"
                                label="Fecha de Hoy"
                                variant="outlined"
                                type='date'
                                fullWidth
                                value={fechaHoy}
                                onChange={handleFechaHoy}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                id="noOrden"
                                name="noOrden"
                                label="# Numero de Orden"
                                variant="outlined"
                                type='number'
                                fullWidth
                                value={idNewOrder}
                                disabled
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                id="noOrden"
                                name="otExterno"
                                label="# Numero de Orden"
                                variant="outlined"
                                type='number'
                                fullWidth                                                                
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <FormControl fullWidth>
                                <InputLabel id="label-elaboro">Elaboro</InputLabel>
                                <Select
                                    labelId="label-elaboro"
                                    id="elaboro"
                                    name="elaboro"
                                    value={elaboro}
                                    label="Responsable"
                                    // required
                                    onChange={handleChangeelaboro}
                                >
                                    {usuarios.map((elem, i) => {
                                        return (
                                            <MenuItem value={elem.id}>{elem.nombre}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                id="observaciones"
                                name="observaciones"
                                label="Observaciones"
                                variant="outlined"
                                fullWidth
                                multiline
                                rows={4}
                            />
                        </Grid>
                    </Grid>
                </Card>
                <Card sx={{ padding: "20px 10px", margin: '10px 0' }}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <center>
                                <Typography variant='h5' color='primary'><b>Datos del Cliente</b></Typography>
                            </center>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <FormControl fullWidth>
                                <InputLabel id="label-estatus">Cliente</InputLabel>
                                <Select
                                    labelId="label-estatus"
                                    id="cliente"
                                    name="cliente"
                                    value={empresa}
                                    label="Cliente"
                                    onChange={handleEmpresa}
                                >
                                    <MenuItem value={0}>Agregar Nuevo</MenuItem>
                                    {companias.map((i, e) => {
                                        return (
                                            <MenuItem value={i.id} key={e}>{i.nombre}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        {empresa == 0 &&
                            <Grid size={{ xs: 12, md: 6 }}>
                                <TextField
                                    id="empresaNueva"
                                    name="empresaNueva"
                                    label="Nombre"
                                    variant="outlined"
                                    required
                                    fullWidth
                                />
                            </Grid>
                        }
                    </Grid>
                </Card>
                <Card sx={{ padding: "20px 10px", margin: '10px 0' }}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <center>
                                <Typography variant='h5' color='primary'><b>Datos del Vehiculo</b></Typography>
                            </center>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                label="Buscar por placas"
                                value={busqueda}
                                fullWidth
                                onChange={(e) => setBusqueda(e.target.value)}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant='body1' color={busqueda.trim() ? "success" : "error"}>
                                <center>
                                    {busqueda.trim() ? "Coincidencias " + vehiculosFiltrados.length : "Se muestran los ultimos 5 Vehiculos registrados"}
                                </center>
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <FormControl fullWidth>
                                <InputLabel id="label-estatus">Vehiculos</InputLabel>
                                <Select
                                    labelId="label-estatus"
                                    id="carro"
                                    name="carro"
                                    value={carro}
                                    label="Selecciona Uno"
                                    onChange={handleCarro}
                                >
                                    <MenuItem value={0}>Agregar Nuevo <FcPlus /></MenuItem>
                                    {vehiculosFiltrados.map((i, e) => {
                                        return (
                                            <MenuItem value={i.id} key={e}>{i.placas}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <Divider sx={{ margin: "10px 0" }} />
                        </Grid>
                    </Grid>


                    {carro === 0 &&
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, md: 12 }} className="centerH">
                                <div className="imagenVehiculo">
                                    <img src={imageFile} alt="" width={"100%"} />
                                </div>
                            </Grid>
                            <Grid size={{ xs: 12, md: 12 }} className="centerH">
                                <Button
                                    // fullWidth
                                    component="label"
                                    role={undefined}
                                    tabIndex={-1}
                                    size="small"
                                    color={imageFile ? "secondary" : "primary"}
                                    variant={imageFile ? "contained" : "contained"}
                                    startIcon={<CameraAltIcon />}
                                >
                                    {imageFile &&
                                        "Imagen Cargada"
                                    }
                                    {!imageFile &&
                                        "Cargar Imagen"
                                    }
                                    <VisuallyHiddenInput
                                        type="file"
                                        onChange={handleImageChange}
                                        name='imagen'
                                    />
                                </Button>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <TextField
                                    id="placas"
                                    name="placas"
                                    label="Placas"
                                    variant="outlined"
                                    required
                                    fullWidth
                                />
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <TextField
                                    id="marca"
                                    name="marca"
                                    label="Marca"
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <TextField
                                    id="modelo"
                                    name="modelo"
                                    label="Modelo"
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <TextField
                                    id="color"
                                    name="color"
                                    label="Color"
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <TextField
                                    id="kilo"
                                    name="kilo"
                                    label="Kilometraje"
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <TextField
                                    id="vin"
                                    name="vin"
                                    label="VIN"
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    }

                    {carro !== 0 &&
                        <Grid container spacing={2}>
                            {vehiculos
                                .filter(x => x.id === carro)
                                .map((elem, i) => {
                                    return (
                                        <Grid size={{ xs: 12, md: 12 }}>
                                            <Card sx={{ padding: "10px 20px" }}>
                                                <Typography variant='h6' color='primary'><b>Vehiculo</b></Typography>
                                                <Grid container spacing={2}>
                                                    <Grid size={{ xs: 12, md: 4 }} className="centerH">
                                                        <div className="imagenVehiculo">
                                                            <img src={elem.ruta ? "https://apiclimas.abdielaldana.com/" + elem.ruta : imagenotfound} alt="" width={"100%"} />
                                                        </div>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, md: 8 }}>
                                                        <Typography variant="body1" noWrap>
                                                            Placas: <b>{elem.placas}</b>
                                                        </Typography>
                                                        <Typography variant="body1" noWrap>
                                                            Modelo: <b>{elem.marca} {elem.modelo}</b>
                                                        </Typography>
                                                        <Typography variant="body1" noWrap>
                                                            Color: <b>{elem.color}</b>
                                                        </Typography>
                                                        <Typography variant="body1" noWrap>
                                                            Kilometraje: <b>{elem.kilometraje} km</b>
                                                        </Typography>
                                                        <Typography variant="body1" noWrap>
                                                            VIN: <b>{elem.vin}</b>
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Card>
                                        </Grid>
                                    )
                                })}
                        </Grid>
                    }
                </Card>
                <Card sx={{ padding: "20px 10px", margin: '10px 0' }}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <center>
                                <Typography variant='h5' color='primary'><b>Conceptos</b></Typography>
                            </center>
                        </Grid>
                        {conceptos.map((item, index) => (
                            <Grid size={{ xs: 12, md: 12 }} key={index}>
                                <Card sx={{ padding: "15px", marginBottom: "10px" }}>
                                    <Grid container spacing={2}>
                                        <Grid size={{ xs: 6, md: 3 }}>
                                            <TextField
                                                label="Cantidad"
                                                type="number"
                                                fullWidth
                                                value={item.cantidad}
                                                onChange={(e) =>
                                                    cambiarConcepto(index, "cantidad", e.target.value)
                                                }
                                                inputProps={{ min: 1, step: "0.01" }}
                                                required
                                            />
                                        </Grid>

                                        <Grid size={{ xs: 6, md: 3 }}>
                                            <TextField
                                                label="Precio"
                                                type="number"
                                                fullWidth
                                                value={item.precio_unitario}
                                                onChange={(e) =>
                                                    cambiarConcepto(index, "precio_unitario", e.target.value)
                                                }
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">$</InputAdornment>
                                                    )
                                                }}
                                                inputProps={{ min: 0, step: "0.01" }}
                                                required
                                            />
                                        </Grid>

                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <TextField
                                                label="Concepto"
                                                fullWidth
                                                multiline
                                                minRows={2}
                                                value={item.concepto}
                                                onChange={(e) =>
                                                    cambiarConcepto(index, "concepto", e.target.value)
                                                }
                                                required
                                            />
                                        </Grid>

                                        <Grid size={{ xs: 12, md: 12 }} className="centerE">
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                size="small"
                                                onClick={() => eliminarConcepto(index)}
                                                disabled={conceptos.length === 1}
                                            >
                                                Eliminar concepto
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        ))}

                        <Grid size={{ xs: 12, md: 12 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={agregarConcepto}
                            >
                                Agregar concepto
                            </Button>
                        </Grid>
                    </Grid>
                </Card>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }} className="centerE">
                        <Button
                            variant='contained'
                            color='success'
                            size='large'
                            sx={{ marginBottom: '10px' }}
                            type="submit"
                            fullWidth
                            form="nueva-orden-form"
                            disabled={buttonDisabled}
                        >
                            Guardar Orden
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </>

    )
}

export default AddNewOrden